import { useState, useEffect } from "react";

/**
 * A hook that detects if the current viewport is mobile-sized using matchMedia
 * @param query - The media query to match (default: '(max-width: 767px)')
 * @returns True if the media query matches
 */
const useIsMobileViewport = (query = "(max-width: 767px)") => {
    const [matches, setMatches] = useState(false);

    useEffect(() => {
        const mediaQuery = window.matchMedia(query);
        setMatches(mediaQuery.matches);

        mediaQuery.onchange = (event) => {
            setMatches(event.matches);
        };

        return () => {
            mediaQuery.onchange = null;
        };
    }, [query]);

    return matches;
};

export default useIsMobileViewport;
